(function () {
  'use strict';

  var EARTH_RADIUS_MILES = 3958.8;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  function telHref(phone) {
    return phone.replace(/[^\d+]/g, '');
  }

  function directionsHref(address) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
  }

  function parseCityState(address) {
    if (!address) return '';
    var parts = String(address).split(',').map(function (s) { return s.trim(); });
    for (var i = parts.length - 1; i >= 0; i--) {
      var m = parts[i].match(/^([A-Za-z]{2})\s+\d{5}/);
      if (m && i > 0) return parts[i - 1] + ', ' + m[1].toUpperCase();
    }
    return '';
  }

  function suggestIcon(type) {
    if (type === 'store') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>';
  }

  function resolveImage(value, base) {
    if (!value) return '';
    if (/^https?:\/\//i.test(value) || value.charAt(0) === '/') return value;
    return (base || '') + value;
  }

  function distanceMiles(lat1, lng1, lat2, lng2) {
    var toRad = function (deg) { return deg * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function parseSheet(text) {
    var json = JSON.parse(text.substring(text.indexOf('{'), text.lastIndexOf('}') + 1));
    var labels = json.table.cols.map(function (col) { return (col.label || '').trim().toLowerCase(); });
    var indexOf = function () {
      var names = Array.prototype.slice.call(arguments);
      return labels.findIndex(function (label) { return names.indexOf(label) !== -1; });
    };
    var columns = {
      name: indexOf('name', 'title', 'store', 'store name'),
      description: indexOf('description', 'message', 'messages', 'category', 'type'),
      address: indexOf('address', 'store address'),
      latitude: indexOf('latitude', 'lat'),
      longitude: indexOf('longitude', 'lng', 'long', 'lon'),
      phone: indexOf('phone', 'telephone'),
      website: indexOf('website', 'url', 'link'),
      image: indexOf('image', 'photo', 'img', 'picture')
    };
    var cell = function (row, index) {
      return index < 0 || !row.c[index] ? '' : (row.c[index].v == null ? '' : row.c[index].v);
    };
    return json.table.rows.map(function (row) {
      return {
        name: String(cell(row, columns.name)).trim(),
        description: String(cell(row, columns.description)).trim(),
        address: String(cell(row, columns.address)).trim(),
        phone: String(cell(row, columns.phone)).trim(),
        website: String(cell(row, columns.website)).trim(),
        image: String(cell(row, columns.image)).trim(),
        lat: parseFloat(cell(row, columns.latitude)),
        lng: parseFloat(cell(row, columns.longitude))
      };
    }).filter(function (item) { return item.name || item.address; });
  }

  function loadLocations(sheetId, sheetTab) {
    if (sheetId) {
      var url = 'https://docs.google.com/spreadsheets/d/' + sheetId +
        '/gviz/tq?tqx=out:json&sheet=' + encodeURIComponent(sheetTab || 'Resellers');
      return fetch(url).then(function (res) { return res.text(); }).then(parseSheet);
    }
    if (Array.isArray(window.RESELLER_LOCATIONS)) {
      return Promise.resolve(window.RESELLER_LOCATIONS.slice());
    }
    return Promise.resolve([]);
  }

  function createGeocoder() {
    var cache = {};
    try { cache = JSON.parse(localStorage.getItem('reseller_geocache') || '{}'); } catch (e) { cache = {}; }
    return function geocode(query) {
      var key = query.toLowerCase();
      if (cache[key]) return Promise.resolve(cache[key]);
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us,ca&q=' +
        encodeURIComponent(query);
      return fetch(url, { headers: { 'Accept-Language': 'en' } })
        .then(function (res) { return res.json(); })
        .then(function (results) {
          if (!results.length) return null;
          var point = { lat: +results[0].lat, lng: +results[0].lon };
          cache[key] = point;
          try { localStorage.setItem('reseller_geocache', JSON.stringify(cache)); } catch (e) {}
          return point;
        })
        .catch(function () { return null; });
    };
  }

  function pinIcon(active) {
    return L.divIcon({
      className: '',
      iconSize: [26, 36],
      iconAnchor: [13, 36],
      popupAnchor: [0, -40],
      html: '<div class="reseller-locator__pin' + (active ? ' is-active' : '') + '">' +
        '<svg width="26" height="36" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M13 0C5.82 0 0 5.82 0 13c0 9.25 11.2 21.5 12.18 22.56a1.1 1.1 0 0 0 1.64 0C14.8 34.5 26 22.25 26 13 26 5.82 20.18 0 13 0z" fill="currentColor"/>' +
        '<circle cx="13" cy="13" r="5.2" fill="#fff" fill-opacity=".9"/></svg></div>'
    });
  }

  function popupMarkup(item) {
    return '<div class="reseller-locator__popup">' +
      (item.image ? '<img class="reseller-locator__popup-image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.name) + '" onerror="this.style.display=\'none\'">' : '') +
      '<div class="reseller-locator__popup-body">' +
      '<h3 class="reseller-locator__popup-name">' + escapeHtml(item.name) + '</h3>' +
      (item.description ? '<p class="reseller-locator__popup-line reseller-locator__popup-desc"><strong>Description:</strong> ' + escapeHtml(item.description) + '</p>' : '') +
      '<p class="reseller-locator__popup-line"><strong>Store Address:</strong> ' + escapeHtml(item.address) + '</p>' +
      (item.phone ? '<p class="reseller-locator__popup-line"><strong>Phone:</strong> <a href="tel:' + telHref(item.phone) + '">' + escapeHtml(item.phone) + '</a></p>' : '') +
      '<div class="reseller-locator__popup-actions">' +
      '<a class="reseller-locator__popup-action reseller-locator__popup-action--primary" href="' + directionsHref(item.address) + '" target="_blank" rel="noopener">Directions</a>' +
      (item.website ? '<a class="reseller-locator__popup-action reseller-locator__popup-action--ghost" href="' + escapeHtml(item.website) + '" target="_blank" rel="noopener">Visit Store</a>' : '') +
      '</div></div></div>';
  }

  function cardMarkup(item) {
    var phoneLink = item.phone
      ? '<a class="reseller-locator__link" href="tel:' + telHref(item.phone) + '" onclick="event.stopPropagation()">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>Call</a>'
      : '';
    var websiteLink = item.website
      ? '<a class="reseller-locator__link reseller-locator__link--store" href="' + escapeHtml(item.website) + '" target="_blank" rel="noopener" onclick="event.stopPropagation()">Visit Store</a>'
      : '';
    var distance = item.distance != null
      ? '<span class="reseller-locator__distance">' + item.distance.toFixed(1) + ' mi</span>'
      : '';
    return '<div class="reseller-locator__thumb">' +
        (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" onerror="this.remove()">' : '') +
      '</div>' +
      '<div class="reseller-locator__card-body">' +
        '<div class="reseller-locator__card-head"><h3 class="reseller-locator__card-name">' + escapeHtml(item.name) + '</h3>' + distance + '</div>' +
        (item.description ? '<p class="reseller-locator__card-desc">' + escapeHtml(item.description) + '</p>' : '') +
        '<p class="reseller-locator__card-address">' + escapeHtml(item.address) + '</p>' +
        '<div class="reseller-locator__links">' + phoneLink +
          '<a class="reseller-locator__link" href="' + directionsHref(item.address) + '" target="_blank" rel="noopener" onclick="event.stopPropagation()">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l19-9-9 19-2-8-8-2z"/></svg>Directions</a>' +
          websiteLink +
        '</div>' +
      '</div>';
  }

  function initLocator(root) {
    var sheetId = root.getAttribute('data-sheet-id') || '';
    var sheetTab = root.getAttribute('data-sheet-tab') || 'Resellers';
    var imageBase = root.getAttribute('data-image-base') || '';

    var mapEl = root.querySelector('[data-locator-map]');
    var listEl = root.querySelector('[data-locator-list]');
    var countEl = root.querySelector('[data-locator-count]');
    var formEl = root.querySelector('[data-locator-search]');
    var queryEl = root.querySelector('[data-locator-query]');
    var radiusEl = root.querySelector('[data-locator-radius]');
    var locateEl = root.querySelector('[data-locator-locate]');
    var viewEl = root.querySelector('[data-locator-view]');
    var layersEl = root.querySelector('[data-locator-layers]');
    var perPageEl = root.querySelector('[data-locator-perpage]');

    var geocode = createGeocoder();
    var locations = [];
    var markers = [];
    var suggestions = [];
    var suggestEl = null;
    var lastOrigin = null;
    var lastRadius = 0;

    var baseLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', { subdomains: 'abcd', maxZoom: 20 });
    var satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { maxZoom: 19 });
    var satelliteLabels = L.layerGroup([
      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', { maxZoom: 19 }),
      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}', { maxZoom: 19 })
    ]);

    var map = L.map(mapEl, { scrollWheelZoom: true, zoomControl: true, attributionControl: false, layers: [baseLayer] }).setView([41.5, -95], 4);
    var pinLayer = L.layerGroup().addTo(map);
    setTimeout(function () { map.invalidateSize(); }, 200);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { map.invalidateSize(); }, 200);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') map.closePopup();
    });

    if (layersEl) {
      layersEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-layer]');
        if (!button) return;
        layersEl.querySelectorAll('[data-layer]').forEach(function (el) { el.classList.remove('is-active'); });
        button.classList.add('is-active');
        if (button.getAttribute('data-layer') === 'satellite') {
          map.removeLayer(baseLayer);
          satelliteLayer.addTo(map);
          satelliteLabels.addTo(map);
        } else {
          map.removeLayer(satelliteLayer);
          map.removeLayer(satelliteLabels);
          baseLayer.addTo(map);
        }
      });
    }

    if (viewEl) {
      viewEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-view]');
        if (!button) return;
        viewEl.querySelectorAll('[data-view]').forEach(function (el) { el.classList.remove('is-active'); });
        button.classList.add('is-active');
        var listOnly = button.getAttribute('data-view') === 'list';
        root.classList.toggle('reseller-locator--list-only', listOnly);
        if (!listOnly) setTimeout(function () { map.invalidateSize(); }, 60);
      });

      // Default to the List view on mobile (more rows visible without scrolling).
      if (window.matchMedia('(max-width: 768px)').matches) {
        var listButton = viewEl.querySelector('[data-view="list"]');
        if (listButton) {
          viewEl.querySelectorAll('[data-view]').forEach(function (el) { el.classList.remove('is-active'); });
          listButton.classList.add('is-active');
          root.classList.add('reseller-locator--list-only');
        }
      }
    }

    function setActive(index) {
      root.querySelectorAll('.reseller-locator__card').forEach(function (card) {
        card.classList.toggle('is-active', +card.getAttribute('data-index') === index);
      });
      markers.forEach(function (marker, i) { marker.setIcon(pinIcon(i === index)); });
    }

    function render(origin, radius, focus) {
      map.closePopup();
      lastOrigin = origin;
      lastRadius = radius;
      listEl.innerHTML = '';
      pinLayer.clearLayers();
      markers = [];

      var data = locations.filter(function (item) {
        return !isNaN(item.lat) && !isNaN(item.lng);
      }).map(function (item) { return Object.assign({}, item); });

      if (origin) {
        data.forEach(function (item) { item.distance = distanceMiles(origin.lat, origin.lng, item.lat, item.lng); });
        data.sort(function (a, b) { return a.distance - b.distance; });
        if (radius > 0) data = data.filter(function (item) { return item.distance <= radius; });
      }

      var total = data.length;
      var perPage = currentPerPage();
      if (perPage > 0 && data.length > perPage) data = data.slice(0, perPage);

      var shownNote = data.length < total ? ' (showing ' + data.length + ')' : '';
      countEl.innerHTML = origin
        ? '<strong>' + total + '</strong> reseller' + (total !== 1 ? 's' : '') + ' found' + (radius > 0 ? ' within ' + radius + ' mi' : '') + shownNote
        : '<strong>' + total + '</strong> resellers nationwide' + shownNote;

      if (!data.length) {
        listEl.innerHTML = '<li class="reseller-locator__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg><p>No resellers in this area.<br>Try a larger distance or different search.</p></li>';
        if (origin) map.setView([origin.lat, origin.lng], 7);
        return;
      }

      var focusIndex = -1;
      var bounds = [];
      var isNarrow = window.matchMedia('(max-width: 768px)').matches;
      data.forEach(function (item, index) {
        var marker = L.marker([item.lat, item.lng], { icon: pinIcon(false) });
        marker.bindPopup(popupMarkup(item), {
          className: 'reseller-locator__leaflet-popup',
          maxWidth: isNarrow ? 250 : 312,
          minWidth: isNarrow ? 230 : 300,
          // Extra top padding keeps the popup (name + close button) clear of the
          // zoom and Map/Satellite controls pinned to the top of the map.
          autoPanPaddingTopLeft: isNarrow ? [12, 58] : [28, 58],
          autoPanPaddingBottomRight: isNarrow ? [12, 12] : [28, 28],
          closeButton: true
        });
        markers.push(marker);
        pinLayer.addLayer(marker);
        bounds.push([item.lat, item.lng]);

        var card = document.createElement('li');
        card.className = 'reseller-locator__card';
        card.setAttribute('data-index', index);
        card.innerHTML = cardMarkup(item);
        card.addEventListener('click', function () {
          setActive(index);
          map.setView([item.lat, item.lng], Math.max(map.getZoom(), 9), { animate: false });
          marker.openPopup();
        });
        listEl.appendChild(card);

        marker.on('click', function () {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        marker.on('popupopen', function () { setActive(index); });

        if (focus && focusIndex < 0 &&
            Math.abs(item.lat - focus.lat) < 1e-4 && Math.abs(item.lng - focus.lng) < 1e-4) {
          focusIndex = index;
        }
      });

      if (focusIndex >= 0) {
        var f = data[focusIndex];
        map.setView([f.lat, f.lng], Math.max(map.getZoom(), 11), { animate: false });
        setActive(focusIndex);
        markers[focusIndex].openPopup();
        var activeCard = listEl.querySelector('[data-index="' + focusIndex + '"]');
        if (activeCard) activeCard.scrollIntoView({ block: 'nearest' });
        return;
      }

      if (origin) bounds.push([origin.lat, origin.lng]);
      if (bounds.length > 1) map.fitBounds(bounds, { padding: [50, 50], maxZoom: 11 });
      else map.setView(bounds[0], 11);
    }

    function currentRadius() {
      return radiusEl ? +radiusEl.value : 0;
    }

    function currentPerPage() {
      return perPageEl ? +perPageEl.value : 0;
    }

    if (perPageEl) {
      perPageEl.addEventListener('change', function () { render(lastOrigin, lastRadius); });
    }

    function buildSuggestions(items) {
      var seenCity = {}, seenName = {}, out = [];
      items.forEach(function (item) {
        if (isNaN(item.lat) || isNaN(item.lng)) return;
        if (item.name) {
          var nk = item.name.toLowerCase();
          if (!seenName[nk]) {
            seenName[nk] = 1;
            out.push({ label: item.name, sub: item.address, lat: item.lat, lng: item.lng, type: 'store', query: item.name });
          }
        }
        var cs = parseCityState(item.address);
        if (cs) {
          var ck = cs.toLowerCase();
          if (!seenCity[ck]) {
            seenCity[ck] = 1;
            out.push({ label: cs, sub: '', lat: item.lat, lng: item.lng, type: 'city', query: cs });
          }
        }
      });
      return out;
    }

    function initSuggestUI() {
      if (!queryEl) return;
      var field = queryEl.parentNode;
      field.style.position = 'relative';
      suggestEl = document.createElement('ul');
      suggestEl.className = 'reseller-locator__suggestions';
      suggestEl.hidden = true;
      field.appendChild(suggestEl);

      var activeIdx = -1;
      var current = [];

      function hide() { suggestEl.hidden = true; activeIdx = -1; }
      function highlight(n) {
        activeIdx = n;
        var lis = suggestEl.querySelectorAll('li');
        lis.forEach(function (li, i) { li.classList.toggle('is-active', i === n); });
        if (lis[n]) lis[n].scrollIntoView({ block: 'nearest' });
      }
      function choose(s) {
        if (!s) return;
        queryEl.value = s.query;
        hide();
        render({ lat: s.lat, lng: s.lng }, currentRadius(), s.type === 'store' ? { lat: s.lat, lng: s.lng } : null);
      }
      function show(list) {
        current = list;
        if (!list.length) { hide(); return; }
        suggestEl.innerHTML = list.map(function (s, i) {
          return '<li class="reseller-locator__suggestion" data-i="' + i + '">' +
            suggestIcon(s.type) +
            '<span class="reseller-locator__suggestion-text">' +
              '<span class="reseller-locator__suggestion-label">' + escapeHtml(s.label) + '</span>' +
              (s.sub ? '<span class="reseller-locator__suggestion-sub">' + escapeHtml(s.sub) + '</span>' : '') +
            '</span></li>';
        }).join('');
        suggestEl.hidden = false;
        activeIdx = -1;
      }

      queryEl.addEventListener('input', function () {
        var q = queryEl.value.trim().toLowerCase();
        if (q === '') { hide(); if (lastOrigin) render(null, currentRadius()); return; }
        if (q.length < 2) { hide(); return; }
        var matched = suggestions.filter(function (s) { return s.label.toLowerCase().indexOf(q) !== -1; });
        matched.sort(function (a, b) {
          return a.label.toLowerCase().indexOf(q) - b.label.toLowerCase().indexOf(q);
        });
        show(matched.slice(0, 8));
      });

      suggestEl.addEventListener('mousedown', function (event) {
        var li = event.target.closest('[data-i]');
        if (!li) return;
        event.preventDefault();
        choose(current[+li.getAttribute('data-i')]);
      });

      queryEl.addEventListener('keydown', function (event) {
        if (suggestEl.hidden) return;
        if (event.key === 'ArrowDown') { event.preventDefault(); highlight(Math.min(activeIdx + 1, current.length - 1)); }
        else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(Math.max(activeIdx - 1, 0)); }
        else if (event.key === 'Enter' && activeIdx >= 0) { event.preventDefault(); choose(current[activeIdx]); }
        else if (event.key === 'Escape') { hide(); }
      });

      queryEl.addEventListener('blur', function () { setTimeout(hide, 120); });
    }

    initSuggestUI();

    if (formEl) {
      formEl.addEventListener('submit', function (event) {
        event.preventDefault();
        var query = queryEl.value.trim();
        var radius = currentRadius();
        if (!query) { render(null, radius); return; }
        countEl.innerHTML = 'Searching…';
        geocode(query).then(function (origin) {
          if (!origin) { countEl.innerHTML = 'Location not found — try a ZIP or “City, State”.'; return; }
          render(origin, radius);
        });
      });
    }

    if (locateEl) {
      locateEl.addEventListener('click', function () {
        if (!navigator.geolocation) { return; }
        countEl.innerHTML = 'Locating you…';
        navigator.geolocation.getCurrentPosition(function (position) {
          render({ lat: position.coords.latitude, lng: position.coords.longitude }, currentRadius());
        }, function () {
          countEl.innerHTML = 'Could not get your location — search manually.';
        });
      });
    }

    listEl.innerHTML = ('<li class="reseller-locator__skeleton"><div class="reseller-locator__skeleton-bar" style="width:84px;height:84px"></div><div style="flex:1"><div class="reseller-locator__skeleton-bar" style="height:16px;width:60%;margin-bottom:8px"></div><div class="reseller-locator__skeleton-bar" style="height:12px;width:40%;margin-bottom:10px"></div><div class="reseller-locator__skeleton-bar" style="height:12px;width:90%"></div></div></li>').repeat(4);

    loadLocations(sheetId, sheetTab).then(function (data) {
      locations = data;
      locations.forEach(function (item) { item.image = resolveImage(item.image, imageBase); });
      suggestions = buildSuggestions(locations);
      var missing = locations.filter(function (item) {
        return (isNaN(item.lat) || isNaN(item.lng)) && item.address;
      });
      if (!missing.length) { render(null, 0); return; }
      countEl.innerHTML = 'Locating stores…';
      var chain = Promise.resolve();
      missing.forEach(function (item) {
        chain = chain.then(function () {
          return geocode(item.address).then(function (point) {
            if (point) { item.lat = point.lat; item.lng = point.lng; }
            return new Promise(function (resolve) { setTimeout(resolve, 1100); });
          });
        });
      });
      chain.then(function () { suggestions = buildSuggestions(locations); render(null, 0); });
    }).catch(function () {
      locations = Array.isArray(window.RESELLER_LOCATIONS) ? window.RESELLER_LOCATIONS.slice() : [];
      locations.forEach(function (item) { item.image = resolveImage(item.image, imageBase); });
      suggestions = buildSuggestions(locations);
      render(null, 0);
    });
  }

  function boot() {
    document.querySelectorAll('[data-reseller-locator]').forEach(function (root) {
      if (root.dataset.locatorReady) return;
      root.dataset.locatorReady = 'true';
      initLocator(root);
    });
  }

  function whenLeafletReady(callback) {
    if (window.L && window.L.map) { callback(); return; }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (window.L && window.L.map) { clearInterval(timer); callback(); }
      else if (attempts > 100) { clearInterval(timer); }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenLeafletReady(boot); });
  } else {
    whenLeafletReady(boot);
  }

  document.addEventListener('shopify:section:load', function () { whenLeafletReady(boot); });
})();